'use client';

import type { CSSProperties, FC, PropsWithChildren } from 'react';
import { cx } from '../../utils/cx';
import { Typography } from '../Typography';
import styles from './Progress.module.css';

export interface ProgressProps {
  className?: string;
  max: number;
  maxLabel?: string;
  value: number;
  valueLabel?: string;
  pendingValue?: number;
  rangeStart?: number;
  rangeEnd?: number;
  rangeLabel?: string;
}

export const Progress: FC<PropsWithChildren<ProgressProps>> = (props) => {
  const {
    max,
    value,
    pendingValue,
    valueLabel,
    maxLabel,
    rangeEnd,
    rangeStart,
    rangeLabel,
  } = props;

  return (
    <div className={styles.root}>
      {valueLabel && maxLabel && (
        <Typography.Caption className={styles.labels}>
          <div className={styles.labelsValue}>{valueLabel}</div>
          <div className={styles.labelsMax}>{maxLabel}</div>
        </Typography.Caption>
      )}

      <div className={styles.progressBar}>
        {value ? (
          <div
            className={styles.value}
            style={
              { '--value-width': `${(100 / max) * value}%` } as CSSProperties
            }
          />
        ) : null}
        {pendingValue ? (
          <div
            className={styles.pendingValue}
            style={
              {
                '--pending-width': `${(100 / max) * pendingValue}%`,
              } as CSSProperties
            }
          />
        ) : null}
      </div>

      {rangeEnd && rangeStart && (
        <div
          className={styles.range}
          style={
            {
              '--range-width': `${(100 / max) * (rangeEnd - rangeStart)}%`,
              '--range-left': `${(100 / max) * rangeStart}%`,
            } as CSSProperties
          }
        >
          <div className={cx(styles.rangeThumb, styles.rangeThumbStart)} />
          <div className={cx(styles.rangeThumb, styles.rangeThumbEnd)} />
          <div className={styles.rangeLine} />
          <Typography.Caption className={styles.rangeLabel}>
            {rangeLabel}
          </Typography.Caption>
        </div>
      )}
    </div>
  );
};
